module.exports = __webpack_public_path__ + "media/images/ohap_vb logo-21d0625fecf86f7f34ec8c78eed05cf1.svg";